<template>
    <n-card title="Account Management">
      <n-space vertical>
        <n-list>
          <n-list-item v-for="account in accounts" :key="account.id">
            <n-space justify="space-between">
              <n-space align="center">
                <span>{{ account.name }} - {{ account.type }}</span>
              </n-space>
              <n-space>
                <n-button size="small" @click="editAccount(account)">Edit</n-button>
                <n-button size="small" type="error" @click="deleteAccount(account.id)">Delete</n-button>
              </n-space>
            </n-space>
          </n-list-item>
        </n-list>
        <n-button @click="showAccountForm = true">Add Account</n-button>
        <n-modal 
          v-model:show="showAccountForm"
          preset="card"
          :mask-closable="true" 
          :title="isEditing ? 'Edit Account' : 'Add Account'"
          style="width: 60%; max-width: 600px"
        >
          <n-form 
            ref="formRef" 
            :model="formAccount" 
            label-placement="left"
            label-width="100"
          >
            <n-form-item label="Name" path="name">
              <n-input v-model:value="formAccount.name" />
            </n-form-item>
            <n-form-item label="Type" path="type">
              <n-select v-model:value="formAccount.type" :options="accountTypes" />
            </n-form-item>
            <n-form-item label="Date" path="date">
              <n-date-picker 
                v-model:value="formAccount.date" 
                type="date"
              />
            </n-form-item>
            <n-form-item 
              v-if="formAccount.type === 'Saving'" 
              label="Interest Rate (%)" 
              path="interest_rate"
            >
              <n-input-number 
                v-model:value="formAccount.interest_rate"
                :min="0"
                :max="100"
                :precision="2"
                style="width: 100%"
              />
            </n-form-item>
            <n-form-item 
              v-if="formAccount.type === 'Saving'" 
              label="Monthly Contribution" 
              path="monthly_contribution"
            >
              <n-input-number 
                v-model:value="formAccount.monthly_contribution"
                :min="0"
                :precision="2"
                style="width: 100%"
              />
            </n-form-item>
            <div style="text-align: right">
              <n-button type="primary" @click="submitForm">
                {{ isEditing ? 'Update' : 'Add' }}
              </n-button>
            </div>
          </n-form>
        </n-modal>
      </n-space>
    </n-card>
  </template>
  
<script setup>
import { useAccountStore } from '../stores/accountStore.js';
import { onMounted, computed, ref } from 'vue';
import { NInputNumber } from 'naive-ui';

const accountStore = useAccountStore();
const accounts = computed(() => accountStore.accounts);
const showAccountForm = ref(false);
const isEditing = ref(false);
const editingId = ref(null);
const formAccount = ref({
  name: '',
  type: null,
  date: null,
});

const accountTypes = [
  { label: 'Bank', value: 'Bank' },
  { label: 'Saving', value: 'Saving' },
];

onMounted(() => {
  accountStore.fetchAccounts();
});

const resetForm = () => {
  formAccount.value = {
    name: '',
    type: null,
    date: null,
  };
  isEditing.value = false;
  editingId.value = null;
  showAccountForm.value = false;
};

const deleteAccount = async (id) => {
  try {
    await accountStore.deleteAccount(id);
  } catch (error) {
    console.error('Error deleting account:', error);
  }
};

const editAccount = (account) => {
  isEditing.value = true;
  editingId.value = account.id;
  formAccount.value = {
    ...account,
    date: account.date ? new Date(account.date).getTime() : null
  };
  showAccountForm.value = true;
};

const submitForm = async () => {
  try {
    if (isEditing.value) {
      await accountStore.updateAccount(editingId.value, formAccount.value);
    } else {
      await accountStore.addAccount(formAccount.value);
    }
    resetForm();
  } catch (error) {
    console.error('Error submitting form:', error);
  }
};

</script>